function initHisgroHairTest(root) {
  if (!root || root.__hairTestReady) return;
  root.__hairTestReady = true;

  var ORDER = ['age', 'duration', 'hair_stage', 'family_history', 'recent_experience', 'minoxidil'];
  var SCORE = {
    hair_stage: { stage1: 10, stage2: 20, stage3: 30, stage4: 45, stage5: 50, stage6: 55 },
    duration: { less_than_3m: 0, '3_6m': 2, '6_12m': 4, '1y_plus': 7 },
    family_history: { father: 5, both: 5, mother: 3, not_sure: 1, no: 0 },
    age: { '18-25': 0, '26-35': 1, '36-45': 2, '46-55': 3, '55+': 3 }
  };
  var RESULTS = {
    1: { title: 'Stage 1 — Early shedding', text: [
      'You are noticing more hair fall or slightly less density, but there is no clear pattern at the hairline or crown yet.',
      'This is the easiest stage to act on. Focus on nutrition, scalp health and reducing breakage before considering stronger actives.'
    ]},
    2: { title: 'Stage 2 — Early pattern thinning', text: [
      'Your answers point to thinning that is starting to follow a pattern, usually at the temples or hairline, and has been going on for a while.',
      'A minoxidil-based routine with nutritional support is the standard first step at this stage. Consistency for 4–6 months matters more than anything else.'
    ]},
    3: { title: 'Stage 3 — Established thinning', text: [
      'Thinning at the crown or hairline is now visible and has likely been progressing for a year or more, or runs in your family.',
      'This stage calls for a consistent routine: minoxidil on the scalp, a scalp-friendly shampoo and daily nutritional support. A derma roller can be added to improve absorption — ask a professional about suitability first.'
    ]},
    4: { title: 'Stage 4 — Advanced hair loss', text: [
      'You can see clear patches or large areas of scalp. Topical products can still help maintain and thicken remaining hair, but expectations should be realistic.',
      'We recommend the most complete routine and, in parallel, a consultation with a dermatologist to discuss prescription options.'
    ]}
  };
  var NOTES = {
    triggers: 'Stress, poor sleep, illness or diet changes can cause temporary shedding on top of any pattern — addressing them often improves results.',
    current: 'Since you already use minoxidil, keep going: results typically take 4–6 months and stopping reverses gains.',
    stopped: 'If you stopped minoxidil earlier, restarting and staying consistent is the single biggest factor in seeing results.'
  };

  var quiz = root.querySelector('[data-quiz]');
  var result = root.querySelector('[data-result]');
  var steps = ORDER.map(function (k) { return root.querySelector('[data-step="' + k + '"]'); });
  var back = root.querySelector('[data-back]');
  var bar = root.querySelector('[data-progress-bar]');
  var barFill = bar.querySelector('span');
  var label = root.querySelector('[data-progress-label]');
  var pct = root.querySelector('[data-progress-pct]');
  var answers = {};
  var index = 0;

  function scrollTop() {
    var top = root.getBoundingClientRect().top + window.pageYOffset - 100;
    if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'auto' });
  }

  function show(i) {
    index = i;
    steps.forEach(function (s, n) { if (n === i) s.setAttribute('data-active', ''); else s.removeAttribute('data-active'); });
    var p = Math.round((i / ORDER.length) * 100);
    barFill.style.width = p + '%';
    bar.setAttribute('aria-valuenow', p);
    pct.textContent = p + '%';
    label.textContent = 'Question ' + (i + 1) + ' of ' + ORDER.length;
    back.hidden = i === 0;
    var first = steps[i].querySelector('.ht-opt');
    if (first) first.focus({ preventScroll: true });
    scrollTop();
  }

  function score() {
    var s = (SCORE.hair_stage[answers.hair_stage] || 0) + (SCORE.duration[answers.duration] || 0) + (SCORE.family_history[answers.family_history] || 0) + (SCORE.age[answers.age] || 0);
    if (s < 18) return 1;
    if (s < 29) return 2;
    if (s < 44) return 3;
    return 4;
  }

  function finish() {
    var stage = score();
    var r = RESULTS[stage];
    root.querySelector('[data-result-badge]').textContent = 'Your result';
    root.querySelector('[data-result-title]').textContent = r.title;
    var html = r.text.map(function (t) { return '<p>' + t + '</p>'; });
    var ex = answers.recent_experience || [];
    if (ex.length && ex.indexOf('none') === -1) html.push('<p>' + NOTES.triggers + '</p>');
    if (answers.minoxidil === 'current') html.push('<p>' + NOTES.current + '</p>');
    if (answers.minoxidil === 'stopped') html.push('<p>' + NOTES.stopped + '</p>');
    root.querySelector('[data-result-text]').innerHTML = html.join('');
    root.querySelectorAll('[data-reco]').forEach(function (el) {
      if (el.getAttribute('data-reco') === String(stage)) el.setAttribute('data-active', ''); else el.removeAttribute('data-active');
    });
    var tags = root.querySelector('[data-lead-tags]');
    if (tags) tags.value = 'hair-test,hair-test-stage-' + stage;
    quiz.hidden = true;
    result.setAttribute('data-active', '');
    result.focus({ preventScroll: true });
    scrollTop();
  }

  function next() {
    if (index + 1 < ORDER.length) show(index + 1); else finish();
  }

  steps.forEach(function (step, i) {
    var key = ORDER[i];
    var multi = step.hasAttribute('data-multi');
    var opts = step.querySelectorAll('.ht-opt');
    opts.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (multi) {
          var pressed = btn.getAttribute('aria-pressed') === 'true';
          if (btn.hasAttribute('data-exclusive')) {
            opts.forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
            btn.setAttribute('aria-pressed', pressed ? 'false' : 'true');
          } else {
            btn.setAttribute('aria-pressed', pressed ? 'false' : 'true');
            var ex = step.querySelector('[data-exclusive]');
            if (ex) ex.setAttribute('aria-pressed', 'false');
          }
          step.querySelector('[data-error]').hidden = true;
          return;
        }
        opts.forEach(function (o) { o.setAttribute('aria-checked', 'false'); });
        btn.setAttribute('aria-checked', 'true');
        answers[key] = btn.getAttribute('data-value');
        window.setTimeout(next, 160);
      });
    });
    if (multi) {
      step.querySelector('[data-continue]').addEventListener('click', function () {
        var chosen = [];
        opts.forEach(function (o) { if (o.getAttribute('aria-pressed') === 'true') chosen.push(o.getAttribute('data-value')); });
        if (!chosen.length) { step.querySelector('[data-error]').hidden = false; return; }
        answers[key] = chosen;
        next();
      });
    }
    // Arrow-key navigation inside a group
    step.addEventListener('keydown', function (e) {
      if (['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft'].indexOf(e.key) === -1) return;
      var list = Array.prototype.slice.call(opts);
      var cur = list.indexOf(document.activeElement);
      if (cur === -1) return;
      e.preventDefault();
      var dir = (e.key === 'ArrowDown' || e.key === 'ArrowRight') ? 1 : -1;
      list[(cur + dir + list.length) % list.length].focus();
    });
  });

  back.addEventListener('click', function () { if (index > 0) show(index - 1); });

  var restart = root.querySelector('[data-restart]');
  if (restart) restart.addEventListener('click', function () {
    answers = {};
    root.querySelectorAll('.ht-opt').forEach(function (o) {
      if (o.hasAttribute('aria-checked')) o.setAttribute('aria-checked', 'false');
      if (o.hasAttribute('aria-pressed')) o.setAttribute('aria-pressed', 'false');
    });
    result.removeAttribute('data-active');
    quiz.hidden = false;
    show(0);
  });

  // If the lead form just posted (page reload), reopen the result for the stage stored in the tag field is not possible
  // without server state, so keep the quiz visible; the success message shows inside the result once retaken.
  if (root.dataset.leadForm === 'true' && (window.location.hash === '#HairTestLead' || /customer_posted=true/.test(window.location.search))) {
    var t = root.querySelector('.ht-lead__success');
    if (t) {
      quiz.hidden = true;
      result.setAttribute('data-active', '');
      root.querySelector('[data-result-title]').textContent = 'Thanks — check your inbox';
      root.querySelector('[data-result-text]').innerHTML = '<p>Your personalised routine is on its way. Retake the test any time to see your recommendation again.</p>';
    }
  }
  // Always start from a clean state (covers theme-editor re-renders that serialise old attributes)
  root.querySelectorAll('.ht-opt').forEach(function (o) {
    if (o.hasAttribute('aria-checked')) o.setAttribute('aria-checked', 'false');
    if (o.hasAttribute('aria-pressed')) o.setAttribute('aria-pressed', 'false');
  });
  result.removeAttribute('data-active');
  quiz.hidden = false;
  show(0);
}

if (!customElements.get('hisgro-hair-test')) {
  customElements.define('hisgro-hair-test', class extends HTMLElement {
    connectedCallback() { initHisgroHairTest(this); }
  });
}
